// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from "firebase/firestore"; // Import Firestore
import { getStorage } from "firebase/storage"; // Import Storage
import { getAuth } from "firebase/auth"; // Import getAuth
import { getFunctions } from "firebase/functions"; // Import Functions
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAkWExsvfk3wosY_JEwnhWzF79kt_389iQ",
  authDomain: "mila2-2252e.firebaseapp.com",
  projectId: "mila2-2252e",
  storageBucket: "mila2-2252e.firebasestorage.app",
  messagingSenderId: "930699725629",
  appId: "1:930699725629:web:84f4c27269183e43db9354",
  measurementId: "G-NVB0CZYQ3F",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
let analytics = null;
if (typeof window !== "undefined") {
  isSupported()
    .then((supported) => {
      if (supported) {
        analytics = getAnalytics(app);
      }
    })
    .catch((error) => {
      console.warn("Firebase Analytics is unavailable:", error);
    });
}
const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager(),
  }),
}); // Initialize Firestore with durable offline cache
const storage = getStorage(app); // Initialize Storage
const auth = getAuth(app); // Initialize Auth
const functions = getFunctions(app, "asia-southeast1"); // Initialize Functions

const API_BASE_URL =
  "https://asia-southeast1-mila2-2252e.cloudfunctions.net/api";

export {
  app,
  analytics,
  db,
  storage,
  auth,
  functions,
  firebaseConfig,
  API_BASE_URL,
};
